import {useEffect, useState} from 'react'
import {useHeaderBreadcrumb} from '../../_metronic/layout/core'
import {useLang} from '../../_metronic/i18n/Metronici18n'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {toAbsoluteUrl} from '../../_metronic/helpers'
import {homeListCategoryTree} from '../modules/auth/core/_requests'
import {AxiosError} from 'axios'
import {useIntl} from 'react-intl'

function Tray() {
  const lang = useLang()
  const intl = useIntl()
  const {setChangeTitle, setChangeBeforeTitle, setReturnPath} = useHeaderBreadcrumb()

  const trayNumber = useLocation()

  const [categoryList, setCategoryList] = useState<any[]>([])
  const [selectCategory, setSelectCategory] = useState(
    Number(trayNumber.pathname.split('-')[1]) || 1
  )

  const getList = async () => {
    try {
      const {data} = await homeListCategoryTree(true, 0, 0, '', lang, '', '')
      setCategoryList(data[1] ? data[1].subList /*data[1].subList[0].subList*/ : null)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  useEffect(() => {
    getList()
  }, [])

  useEffect(() => {
    setChangeTitle('')
    setChangeBeforeTitle('')
    setReturnPath('')
  }, [])

  const navigate = useNavigate()
  useEffect(() => {
    let isMounted = true

    // Check if the component is still mounted before navigating
    if (isMounted) {
      navigate(`/trays/tray-${selectCategory}`)
    }

    // Clean up function to set isMounted to false when component unmounts
    return () => {
      isMounted = false
    }
  }, [selectCategory])

  return (
    <>
      {/*}
      <div className='toolbar py-2 px-0 ' id='kt_toolbar'>
        <div
          id='kt_toolbar_container'
          className={clsx(
            classes.toolbarContainer.join(' '),
            'd-flex align-items-center px-0 px-lg-8'
          )}
        >
          {config.pageTitle?.display && <DefaultTitle />}
          <div className='flex-grow-1 flex-shrink-0 me-5'></div>
          <div className='d-flex align-items-center'>
            <Link
              to='/dashboard'
              className='btn btn-outline border-gray-600 btn-sm d-flex flex-center h-35px h-lg-40px'
            >
              Home<span className='d-none d-sm-inline ms-1'>Page</span>
            </Link>
          </div>
        </div>
      </div>
          {*/}
      <div className='row g-5 gx-xl-10 mt-md-n16 mt-2'>
        <div className='col-xxl-12'>
          <div className='row gy-5 gy-xl-10'>
            <div className='card-body pt-6'>
              <ul className='nav nav-pills nav-pills-custom mb-3' role='tablist'>
                {categoryList &&
                  categoryList.map((item, index) => (
                    <li className='nav-item mb-3 me-3 me-lg-6' role='presentation' key={index}>
                      <a
                        className={`nav-link btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden w-80px h-85px pt-5 pb-2 ${
                          index + 1 === selectCategory ? ' active' : ''
                        }`}
                        id={`kt_stats_widget_16_tab_link_${index}`}
                        data-bs-toggle='pill'
                        href={`#kt_stats_widget_16_tab_${index}`}
                        aria-selected='true'
                        role='tab'
                        onClick={() => setSelectCategory(index + 1)}
                        key={index}
                      >
                        {/* Your tab content */}
                        <div className='nav-icon mb-3'>
                          <i className='ki-duotone ki-book fs-1'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                            <span className='path3'></span>
                            <span className='path4'></span>
                          </i>
                        </div>
                        <span className='nav-text text-gray-800 fw-bold fs-6 lh-1'>
                          {item.nodeAd}
                        </span>
                        <span className='bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary'></span>
                      </a>
                    </li>
                  ))}
              </ul>
              <div className='tab-content'>
                {categoryList &&
                  categoryList.map((item, index) => (
                    <div
                      key={index}
                      className={`tab-pane ${
                        index + 1 === selectCategory ? 'active show' : 'fade'
                      }`}
                      id={`kt_stats_widget_16_tab_${index}`}
                      role='tabpanel'
                      aria-labelledby={`kt_stats_widget_16_tab_link_${index}`}
                    >
                      <div className='row g-5'>
                        {categoryList[selectCategory - 1].subList.map((i: any, index2: number) => {
                          return (
                            <div className='col-md-2 col-xl-3' key={index2}>
                              <Link
                                //  to='/tray/selectTrayContent'
                                to={`/trays/tray-${selectCategory}/experiment-${index2 + 1}`}
                                state={{lesson: categoryList[selectCategory - 1], id: i.id}}
                                className=''
                              >
                                <div className='card border border-hover-primary min-h-175px'>
                                  <div className='card-header border-0 pt-9'>
                                    <div className='card-title m-0'>
                                      <div className='symbol symbol-50px w-50px border'>
                                        <img
                                          src={toAbsoluteUrl('/media/logos/data-science.png')}
                                          alt='image'
                                          className='p-1'
                                        />
                                      </div>
                                    </div>
                                    <div className='card-toolbar'>
                                      <span className='badge badge-light-primary fw-bold me-auto px-4 py-3 border border-dashed border-primary'>
                                        {intl.formatMessage({id: 'TRAYPAGE.TRAY'})} {index + 1}
                                      </span>
                                    </div>
                                    <div className='card-body p-9'>
                                      <span className='badge badge-light-danger fw-bold me-auto px-1 py-1 border  border-danger'>
                                        {i?.nodeAd}
                                      </span>
                                      <div className='fs-3 fw-bold text-dark'>{i?.nodeAd}</div>
                                      <p className='text-gray-400 fw-semibold fs-5 mt-1 mb-7 min-vw-100'>
                                        {i?.description}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Tray
